<div class="m-0 row justify-content-center">
    <div class="col-auto p-5" *ngIf="!isLoggedIn">

        <div class="div-secure">
            <form *ngIf="!isLoggedIn" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>

                <div class="form-group">
                    <h3>Observatorio Nacional de Prospectiva</h3>
                </div>
                <br>

                <div class="form-group">
                    <label for="email">Usuario</label>
                    <input type="email" class="form-control" name="email" [(ngModel)]="form.email" required
                        #email="ngModel" />
                    <div class="alert alert-danger" role="alert" *ngIf="email.errors && f.submitted">
                        Falta el correo electronico!
                    </div>
                </div>
                <div class="form-group">
                    <label for="pass">Contraseña</label>
                    <input type="password" class="form-control" name="pass" [(ngModel)]="form.pass" required
                        minlength="6" #pass="ngModel" />
                    <div class="alert alert-danger" role="alert" *ngIf="pass.errors && f.submitted">
                        <div *ngIf="pass.errors['required']">Falta la contraseña!</div>
                        <div *ngIf="pass.errors['minlength']">
                            El password debe contener al menos 6 carateres
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <button class="btn btn-outline-dark btn-secure">
                        Acceder
                    </button>
                </div>
                <div class="form-group">
                    <div class="alert alert-danger" role="alert" *ngIf="f.submitted && isLoginFailed">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMessage }}
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>